const axios = require('axios');
var QS = require('qs');
import local from './local.js'
import baseUrl from './baseUrl.js'
import { Loading } from 'element-ui'

// loading进度条设置
let globalLoading
function startLoading () {
  globalLoading = Loading.service({
    lock: true,
    text: '',
    spinner:'el-icon-loading',
    customClass:'load_icon',
    background: 'rgba(255, 255, 255, 0.6)'
  })
}

function endLoading () {
  setTimeout(() => {
    globalLoading.close()
  }, 500)
}


const instance = axios.create({
  timeout: 300000,
	withCredentials: true,
	baseURL: baseUrl.Api,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
});

// 添加token
instance.defaults.headers.common['channel'] = 'jundawebsite';

// 添加请求拦截器
instance.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  // console.log('请求拦截器')
	let userInfo = local.get('userInfo');
	if (userInfo && userInfo.token ) {
		config.headers.token = userInfo.token
	}
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});

// 添加响应拦截器
instance.interceptors.response.use(function (response) {
  // 对响应数据做点什么
  return response;
}, function (error) {
  // 对响应错误做点什么
  return Promise.reject(error);
});

/*
Promise 是一个构造函数 接收一个函数为参数
resolve() 异步操作执行成功后的回调函数, Promise的状态置为fullfiled
reject() 异步操作执行失败后的回调函数,Promise的状态置为rejected
*/
// get 请求
export function getRequest(url, params = {}, headers = {}) {
	startLoading ();
  return new Promise((resolve, reject) => {
    instance({
      url,
      method: 'get',
      params,
      headers
    }).then(res => {
			endLoading ()
      resolve(res.data);
    }).catch(err => {
			endLoading ()
      reject(err.data);
    })
  });
}


// post 请求
export function postRequestJson(url, data = {}) {
  // data = QS.stringify(data)
	startLoading ();
  return new Promise((resolve, reject) => {
    instance({
      url,
      method: 'post',
			data,
			headers:{
				'content-type':"application/json"
			}
    }).then(res => {
			endLoading ()
      resolve(res.data);
    }).catch(err => {
			endLoading ()
      reject(err.data);
    })
  });
}

// post 表单请求
export function postRequestFrom(url, data = {}, headers = {}) {
	startLoading ();
  data = QS.stringify(data)
  return new Promise((resolve, reject) => {
    instance({
      url,
      method: 'post',
			data,
			headers
    }).then(res => {
			endLoading ()
      resolve(res.data);
    }).catch(err => {
			endLoading ()
      reject(err.data);
    })
  });
}

export function getDownLoad(url, params) {
	startLoading ();
  return new Promise((resolve, reject) => {
		instance({
			url,
			method:'get',
			params,
			responseType:'blob',
			ContentType:'application/json',
		}).then( res=> {
			endLoading ()
      resolve(res.data);
    })
    .catch(err => {
			endLoading ()
      reject(err.data);
    })
  });
}

export function postUpLoad(url, data) {
	startLoading ();
  return new Promise((resolve, reject) => {
    instance({
			url,
			method: 'post',
      data,
			responseType:'blob',
			ContentType:'application/json',
			}).then(res => {
				endLoading ()
				resolve(res.data);
			})
    .catch(err => {
			endLoading ()
      reject(err.data);
    })
  });
}